import { render } from "./HorarioPlantillaIntervalo.vue?vue&type=template&id=58315a93"
import script from "./HorarioPlantillaIntervalo.vue?vue&type=script&lang=js"
export * from "./HorarioPlantillaIntervalo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__